import React, { Component } from 'react';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import ModalComponent from '../Layout/Modal';
import { message } from '../../_constants';
import CustomLinkedIN from '../Linkdin/CustomLinkedIN.js';
import { Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
//import { Button, Pagination, PaginationItem, PaginationLink, Modal, ModalHeader, ModalBody} from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { notification } from 'antd';
import { uploadResumeFile, reqUestDeniedByCity, getAllCityByCountryAction, getAllCountryAction } from '../../actions/FindRecCompany';
import { sendResumeAction } from '../../actions/SendResume';
import { getAllHome } from '../../actions/home';
import { userJobListAction } from '../../actions/job';
import $ from 'jquery';
//import loadingImage from "../loadingImageRc.gif";
import { listCityCountryStateAction } from '../../actions/Admin/CountryCityAction'
import { getRecruiterView } from '../../actions/home'
import logo from '../../image/profile-logo.png';

let className = [];
let fieldsArr = [];
let peginationButton = [];
let carts = {};

class SearchJobCompanyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: [],
            code: '',
            fieldSelct: '',
            disabledButton: false,
            detailsModal: false,
            resumeSectionModel: false,
            listStatus: true,
            resUmeUpload: false,
            resumeNotSelect: false,
            sendResumeOption: true,
            requestServer: true,
            fileName: "",
            categoryId: "",
            emailId: "",
            reqObj: { search: "" },
            formData: {},
            detailsData: {},
            resumeSendFor: "",
            tags: [],
            list: [],
            suggestions: [],
            fieldOption: [],
            tagvalue: [],
            checkedValue: [],
            optionSelect: [],
            jobcount: 0,
            jobList: [],
            jobRequest: false,
            totalCount: 0,
            activeButton: 1,
            selectResumeType: "upload",
            sendResumeForType: "job",
            viewDataDetails: {},
            popoverOpen: {},
            viewRecruter: true,
            userData: JSON.parse(localStorage.getItem('userData')),
            countrySelect: JSON.parse(localStorage.getItem('locationCountry')),
        };
        this.pagePrvBack = this.pagePrvBack.bind(this);
    }

    componentWillMount() {
        const { match } = this.props;
        const { recruterId, city } = match.params;
        if (recruterId) {
            this.props.getRecruiterView({ recruterId: recruterId })
        }
        const userData = JSON.parse(localStorage.getItem('userData'));
        if ((userData && userData.userType === "company") || (userData && userData.userType === "recruiter")) {
            this.props.history.push({
                pathname: "/dashboard-home",
                state: { reqObj: "" }
            });
        }

        if (localStorage.getItem('userLogin') === "true") {
            const userData = JSON.parse(localStorage.getItem('userData'))
            if (userData && userData.userType === "user") {
                this.setState({
                    sendResumeOption: false
                })
            }
        }

        let cuntryReqObj = {
            countryName: this.state.countrySelect,
        }
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "specializations": [],
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }

        this.props.getAllHome(reqObj);
        // this.props.getAllCityByCountryAction(cuntryReqObj)
        // this.props.getAllCountryAction()
    }

    componentDidMount() {
        // this.suggeStionPost(10, 0);
    }

    suggeStionPost = (limit, page, tvalue) => {
        const { location, match } = this.props;
        const { recruterId, city } = match.params;
        const { reqObj, tagvalue, viewDataDetails } = this.state;

        if (tvalue && tvalue.length > 0) {
            tagvalue.push(tvalue);
        }

        let reqObjs = {
            "limit": limit,
            "offset": page,
            "order": "createdAt",
            "direction": "asc",
            "categoryId": reqObj && reqObj.fieldSelct,
        }
        if (viewDataDetails) {
            reqObjs.companyId = viewDataDetails._id;
        }

        this.setState({
            listStatus: true,
            jobRequest: true,
            requestServer: true
        })
        this.props.userJobListAction(reqObjs);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.recruiterView && nextProps.recruiterView.data && nextProps.recruiterView.statusCode == 200 && this.state.viewRecruter) {
            this.setState({
                viewRecruter: false,
                viewDataDetails: nextProps.recruiterView.data
            }, function () {
                this.suggeStionPost(10, 0)
            })
        }
        if (nextProps.jobType === "userJobList" && nextProps.jobResponse && nextProps.jobResponse.statusCode === 200 && this.state.jobRequest) {
            this.setState({
                jobcount: nextProps.jobResponse.data.count,
                jobList: nextProps.jobResponse.data.data,
                jobRequest: false
            }, (function () {
                const { state } = this.props.location;
                if (state && state.scroll) {
                    window.scrollTo(0, 300);
                }
            }))
        }

        let userDetail = JSON.parse(localStorage.getItem('userData'));
        if (localStorage.getItem('userLogin') === "true" && userDetail.userType !== "admin") {
            this.setState({
                sendResumeOption: false,
                userData: userDetail
            })
        }

        const { listStatus, resUmeUpload, resumeSectionModel } = this.state;

        if (nextProps.resumeSent && nextProps.resumeSent.statusCode === 200 && resumeSectionModel) {
            notification.success({
                message: "Resume Send Successfully",
                className: 'successNotification',
                duration: 3
            });
            this.setState({
                fileName: "",
                resumeSectionModel: !resumeSectionModel,
                resumeNotSelect: false,
                requestServer: false,
            })
        }

        if (nextProps.resume && nextProps.resume.statusCode && nextProps.resume.statusCode === 200 && this.state.resUmeUpload) {

            var reqResume = {
                providerType: this.state.sendResumeForType,
                id: this.state.checkedValue,
                userEmail: this.state.userData.email,
                resumeImage: nextProps.resume.file_name
            }
            this.props.sendResumeAction(reqResume);
            this.setState({
                resUmeUpload: false
            })
        }

        if (nextProps.listPost && Array.isArray(nextProps.listPost.data) && listStatus) {
            var list = this.state.list
            list = [];
            list = nextProps.listPost.data;
            this.setState({
                requestServer: false,
                listStatus: false,
                list: list,
                totalCount: nextProps.listPost.count

            })
        }

        if (nextProps.listPost && nextProps.listPost.statusCode === 500 && nextProps.listPost.status === "Error") {
            var listData = this.state.list
            listData = [];
            listData = nextProps.listPost.data;
            this.setState({
                requestServer: false,
                listStatus: false,
                list: listData,
                totalCount: nextProps.listPost.count
            })
        }

        if (nextProps && nextProps.fields && nextProps.fields.length > 0) {
            var fieldsList = nextProps.fields;
            var option = [];
            for (var i in nextProps.fields) {
                let obj = {
                    value: fieldsList[i]._id,
                    label: fieldsList[i].name
                }
                option.push(obj);
            }
            this.setState({
                fieldsList: nextProps.fields,
                fieldOption: option,
            })

            if (this.state.reqObj && this.state.reqObj.fieldSelct) {
                var fieldSelct = this.state.reqObj.fieldSelct;
                let fieldOption = this.state.fieldOption
                let optionSelect = this.state.optionSelect
                for (var n in fieldSelct) {
                    var index = fieldOption.findIndex(p => p.value == [fieldSelct[n]])
                    if (index > -1) {
                        optionSelect.push(fieldOption[index])
                    }
                }
                this.setState({
                    optionSelect: optionSelect
                });
            }
        }
    }

    viewDetails = (data, name) => {
        var items = document.getElementsByName('fields');

        for (var i = 0; i < items.length; i++) {
            if (items[i].checked === true) {
                items[i].checked = false
            }
        }
        let arrValue = []
        if (!this.state.detailsModal) {
            this.setState({
                popoverOpen: {},
            })
        } else {
            this.setState({
                checkedValue: [],
            })
        }
        this.setState({
            linkPopUp: false,
            detailsModal: !this.state.detailsModal,
            detailsData: data
        })
    }

    pageChange = (value, e) => {
        this.setState({
            activeButton: value,
            listStatus: true
        });
        this.suggeStionPost(10, (value - 1));
    }

    readMoreOption = (value, type, e) => {
        if (type === "right") {
            $('#text' + value).css('display', 'inline');
            $('#down' + value).css('display', 'block');
            $('#dots' + value).css('display', 'none');
            $('#right' + value).css('display', 'none');
        }
        if (type === "down") {
            $('#dots' + value).css('display', 'inline');
            $('#text' + value).css('display', 'none');
            $('#down' + value).css('display', 'none');
            $('#right' + value).css('display', 'inline-block');
        }
    }

    peginationButton(count) {
        peginationButton = []
        var countBtn = this.state.jobcount;
        countBtn = Math.ceil(countBtn / 10)
        for (var i = 0; i < countBtn; i++) {
            var peg = <PaginationItem onClick={this.pageChange.bind(this, i + 1)}>
                <PaginationLink href="#" className={(i + 1) === this.state.activeButton ? "pegBtnactive" : "pegBtn"}>
                    {i + 1}
                </PaginationLink>
            </PaginationItem>
            peginationButton.push(peg)
        }
    }

    toggle = (id) => {
        let popStatus = this.state.popoverOpen;
        let keys = Object.keys(popStatus);
        if (keys && keys.length > 0) {
            for (let y in keys) {
                popStatus[keys[y]] = false;
            }
        }
        if (id) {
            popStatus[id] = popStatus[id] ? false : true;
        }
        this.setState({
            popoverOpen: popStatus
        })
    };

    copyCodeToClipboard = () => {
        const el = this.textArea1
        el.select()
        document.execCommand("copy")
        this.setState({ copySuccess: true })
    }

    handleChangeCheckBox = (vendorId, jobId) => {
        let checkedValue = this.state.checkedValue
        var itemChk = document.getElementById(jobId).checked;
        if (itemChk) {
            let obj = {
                companyId: vendorId,
                jobId: jobId
            }
            checkedValue.push(obj);
        } else {
            var index = checkedValue.findIndex(p => p.jobId === jobId)
            checkedValue.splice(index, 1);
        }

        var items = document.getElementsByName('fields');
        var allCheckBox = document.getElementsByName('allCheckBox');
        var allCheck = false;
        var allNotCheck = true;
        for (var i = 0; i < items.length; i++) {
            if (items[i].checked === true) {
                allCheck = true
            } else {
                allNotCheck = false
            }
        }
        if (allNotCheck && allCheck) {
            allCheckBox[0].checked = true;
        } else {
            allCheckBox[0].checked = false;
        }
        this.setState({
            checkedValue: checkedValue
        })
    }

    allCheckBox = () => {
        let checkedValue = []
        const { jobList } = this.state
        var items = document.getElementsByName('fields');
        var allCheckBox = document.getElementsByName('allCheckBox');
        if (allCheckBox[0].checked) {
            for (var i = 0; i < jobList.length; i++) {
                let obj = {
                    companyId: jobList[i].companyId,
                    jobId: jobList[i]._id
                }
                checkedValue.push(obj);
            }
        } else {
            checkedValue = []
        }
        for (var i = 0; i < items.length; i++) {
            if (items[i].type === 'checkbox')
                items[i].checked = allCheckBox[0].checked;
        }
        this.setState({
            checkedValue: checkedValue
        })
    }

    getValueCheckBox = () => {
        let checkedValue = []
        var items = document.getElementsByName('fields');
        for (var i = 0; i < items.length; i++) {
            if (items[i].checked === true) {
                checkedValue.push(items[i].value);
            }
        }
        return checkedValue;
    }

    handleDelete = (i) => {
        const { tags, tagvalue } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
            tagvalue: tagvalue.filter((tagvalue, index) => index !== i),
        });
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({ tags: newTags });
    }

    handleAddition = (tag) => {
        var tagvalue = tag.text;
        this.setState(state => ({ tags: [...state.tags, tag] }));
        this.setState(state => ({ tagvalue: [...state.tagvalue, tagvalue] }));
        this.suggeStionPost(10, 0, tagvalue);
    }

    sendResume = (e) => {
        var checkValue = this.state.checkedValue;
        if (checkValue.length > 0) {
            this.setState({
                sendResumeForType: "job",
                checkedValue: checkValue,
                resumeSectionModel: !this.state.resumeSectionModel
            })
        } else {
            notification.error({
                message: "Please Select CheckBox",
                className: 'errorNotification',
                duration: 3
            });
        }
    }

    sendResumeToConnect = (data, type, e) => {
        var checkValue = [];
        if (type === "job") {
            let obj = {
                companyId: data.companyId,
                jobId: data._id
            }
            checkValue.push(obj);
        }
        if (type === "jobProvider") {
            checkValue.push(data._id);
        }
        if (checkValue.length > 0) {
            this.setState({
                checkedValue: checkValue,
                sendResumeForType: type,
                resumeSectionModel: !this.state.resumeSectionModel
            })
        } else {
            notification.error({
                message: "Please Select CheckBox",
                className: 'errorNotification',
                duration: 3
            });
        }
    }

    resumeUpload = (e) => {
        this.setState({
            fileName: "",
            resumeSendFor: "",
            resumeSectionModel: !this.state.resumeSectionModel
        })
    }

    sendResumeTo = (e) => {
        if (this.state.selectResumeType === "profile") {
            if (this.state.resumeSendFor !== "") {
                var reqResume = {
                    id: this.state.checkedValue,
                    userEmail: this.state.userData.email,
                    providerType: "job",
                    resumeImage: this.state.resumeSendFor
                }
                this.props.sendResumeAction(reqResume);
            } else {
                this.setState({
                    resumeNotSelect: true
                })
            }
        } else {
            e.preventDefault();
            this.setState({
                resUmeUpload: true
            }, function () {
                var file = document.getElementById("file").files[0];
                this.props.uploadResumeFile(file)
            })
        }
    }

    emailInput = e => {
        e.preventDefault();
        this.setState({
            emailId: e.target.value
        })
    }

    fileSelect = (e) => {
        e.preventDefault();
        var file = document.getElementById("file").files[0];
        this.setState({
            fileName: file.name
        })
    }

    handleChangeAddress = () => { }

    onChangeForSlctResume = (e) => {
        this.setState({
            resumeSendFor: e.target.value,
            resumeNotSelect: false
        })
    }

    handleChangeTypeResume = (e) => {
        let selectResumeType = this.state.selectResumeType
        selectResumeType = e.target.value
        if (selectResumeType === "profile") {
            if (this.state.userData && this.state.userData.resume && this.state.userData.resume !== "") {
                this.setState({
                    selectResumeType: selectResumeType,
                });
            } else {
                notification.error({
                    message: "Please Uplode resume in Profile",
                    className: 'errorNotification',
                    duration: 3
                });
            }
        } else {
            this.setState({
                selectResumeType: selectResumeType,
            });
        }
    }

    searchTextFillter = (e) => {
        e.preventDefault();
        const { activeButton } = this.state
        var reqObj = this.state.reqObj;
        reqObj.search = e.target.value;
        this.setState({
            reqObj: reqObj
        })
        this.suggeStionPost(10, (activeButton - 1));
    }

    searchBox = (e) => {
        e.preventDefault();
        var reqObj = this.state.reqObj;
        reqObj.search = e.target.value;
        this.setState({
            reqObj: reqObj
        })
    }

    pagePrvBack(value, a) {
        let btn = 0;
        if (value === "prv") {
            btn = this.state.activeButton - 1;
        }
        if (value === "next") {
            btn = this.state.activeButton + 1;
        }
        let countBtn = this.state.totalCount;
        countBtn = Math.ceil(countBtn / 10)
        if (btn && (btn <= countBtn ? true : false)) {
            this.setState({
                activeButton: btn,
                listStatus: true
            });
            this.suggeStionPost(10, (btn - 1));
        }
    }

    signIn = () => {
        this.props.history.push({
            pathname: "/sign-in",
            state: { "redirectPath": "/profile" }
        });
    }

    render() {

        this.peginationButton();
        // this.fields();

        const { jobList, viewDataDetails, resumeNotSelect, requestServer, resumeSendFor, fieldOption, fileName, detailsData, sendResumeOption, selectResumeType } = this.state;
        let resumeArr = this.state.userData && this.state.userData.resume ? this.state.userData.resume : [];
        console.log("jobList", jobList)
        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        let education = "";
        let keySkill = "";
        let jobLocation = "";
        if (this.state.detailsModal) {
            education = (detailsData.education).join(",   ");
            keySkill = (detailsData.keySkill).join(",   ");
            jobLocation = $.map(detailsData.jobLocation, function (obj) {
                return obj.city
            }).join(',  ');
        }

        var workingCity = [];
        var categeoryName = [];
        var speciality = [];



        if (Array.isArray(viewDataDetails.companyAddress)) {
            for (var z in viewDataDetails.companyAddress) {
                workingCity.push(<div className="tub">{viewDataDetails.companyAddress[z].city}</div>)
            }
        }

        if (Array.isArray(viewDataDetails.specializations)) {
            for (var y in viewDataDetails.specializations) {
                speciality.push(<div className="tub">{viewDataDetails.specializations[y]}</div>)
            }
        }

        if (Array.isArray(viewDataDetails.categoryId)) {
            for (var x in viewDataDetails.categoryId) {
                var index = fieldOption.findIndex(p => p.value === viewDataDetails.categoryId[x])
                if (index !== -1) {
                    categeoryName.push(<div className="tub">{fieldOption[index].label}</div>);
                }
            }
        }

        let viewModelBody = <div className="row job-row">
            <div className="col-md-12">
                <label className="pf-label"><strong>Job Title</strong> </label>
                <div className="lab-text">{detailsData.title}</div>
            </div>
            <div className="col-md-12">
                <label className="lab-head"><strong>Job Summary</strong></label>
                <div className="lab-text">{detailsData.summary}</div>
            </div>
            <div className="col-md-12">
                <label className="lab-head"><strong>Job Description</strong></label>
                <div className="lab-text">{detailsData.description}</div>
            </div>
            <div className="col-md-4">
                <label className="lab-head"><strong>Employment Type</strong></label>
                <div className="lab-text">{detailsData.employementType}</div>
            </div>
            <div className="col-md-2">
                <label className="lab-head"><strong>Experience</strong></label>
                <div className="lab-text">{detailsData.experienceRequired}</div>
            </div>
            <div className="col-md-2">
                <label className="lab-head"><strong>Opening</strong></label>
                <div className="lab-text">{detailsData.opening}</div>
            </div>
            <div className="col-md-3">
                <label className="lab-head"><strong>Salary</strong></label>
                <div className="lab-text">{detailsData.salary}</div>
            </div>
            <div className="col-md-12"><label className="lab-head"><strong>Key Skill</strong></label>
                <div className="lab-text">{keySkill}</div>
            </div>
            <div className="col-md-12"><label className="lab-head"><strong>Education</strong></label>
                <div className="lab-text">{education}</div>
            </div>
            <div className="col-md-12"><label className="lab-head"><strong>Location</strong></label>
                <div className="lab-text">{jobLocation}</div>
            </div>
        </div>

        let viewModelFooter =
            <div className="wt-100">
                <Button className="buttons1 fl-left" id="popover_b">Share Job</Button>
                <Button className="btn modal-cancel-btn  fl-right" onClick={this.viewDetails}>Close</Button>
                <Button className="btn modal-save-btn  fl-right" onClick={this.sendResumeToConnect.bind(this, detailsData, "job")}>Send Resume</Button>
                <Popover placement="right" isOpen={(this.state.popoverOpen && this.state.popoverOpen.linkPopUp) ? this.state.popoverOpen.linkPopUp : false} target={"popover_b"} toggle={() => this.toggle("linkPopUp")} >
                    <PopoverHeader>
                        <button type="button" onClick={() => this.toggle()} className="closeBtn close color-yg" aria-label="Close"><span aria-hidden="true">×</span></button>
                        <span className="shareLink">
                            <input ref={(textarea) => this.textArea1 = textarea} className="singup-control" value={process.env.REACT_APP_HOST + "/" + viewDataDetails.userUrlLink + "/job/" + detailsData.jobId} />
                            <button data-toggle="tooltip" data-placement="bottom" title="Copy Link" className="copybtn buttons1" onClick={() => this.copyCodeToClipboard()}><i className="fa fa-clone" aria-hidden="true"></i></button>
                        </span>
                    </PopoverHeader>
                </Popover>
            </div>

        return (
            <div className="outer-wrapper" ref={(div) => {
                this.allJobView = div;
            }}>
                <Header props={this.props} />
                <div className="container">
                    <div className="row">
                        <div className="top-row">
                            <div className="col-md-12">
                                <div className="img-job">
                                    <img src={viewDataDetails.image ? this.props.auth.showImage(viewDataDetails.image) : logo} alt="new" className="rounded" scale={4} vertical={0} horizontal={5} />
                                </div>
                                <div className="job-name">{viewDataDetails.firstName}</div>
                                <h5 className="job-type">{viewDataDetails.userType}</h5>
                            </div>
                            <div className="col-md-10 offset-md-1">
                                <div className="detail-right">
                                    <div className="block-1">
                                        <div className="short-label">ShortBio</div>
                                        {viewDataDetails.vanityName &&
                                            <div style={{color:'#0645AD'}}><a target="_blank" rel="noopener noreferrer" href={`https://www.linkedin.com/in/${viewDataDetails.vanityName}`}>https://www.linkedin.com/in/{viewDataDetails.vanityName} {''}<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                                                <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                                            </svg></a></div>
                                        }
                                        <div className="short-name">{viewDataDetails.shortBio}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-10 offset-md-1">
                                <div className="short-city">City</div>
                                <div className="short-name">{workingCity}</div>
                            </div>
                            <div className="col-md-10 offset-md-1">
                                <div className="short-city">Category</div>
                                <div className="cat-name">{categeoryName}</div>
                            </div>
                            <div className="col-md-10 offset-md-1">
                                <div className="short-city">Speciality</div>
                                <div className="short-name">{speciality}</div>
                            </div>
                            <div className="col-md-3 offset-md-9">
                                <Button className="btn mrgn resume-btn1" onClick={this.sendResumeToConnect.bind(this, viewDataDetails, "jobProvider")}>Connect With {viewDataDetails.firstName}</Button>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="job-title">
                                <div className="profile-title">
                                    <h3 className="job-head">Job Posted By {viewDataDetails.firstName} </h3>
                                </div>
                                <div className="job-wrapper">
                                    <div className="search-result-block">
                                        <div>
                                            {jobList.length > 0 &&
                                                <div className="chk-all-block result-content">
                                                    <input type="checkbox" className="all-chk-box" name="allCheckBox" id="select-all" onClick={this.allCheckBox} />
                                                    <label htmlFor="select-all"></label>
                                                    <label className="select-box notcheckkable">Select All</label>
                                                </div>
                                            }
                                            {jobList.map((data, i) => {
                                                var textA = "";
                                                var textB = "";
                                                if (data.summary) {
                                                    var summaryLength = data.summary.length;
                                                    textA = data.summary;
                                                    textB = "";
                                                    if (summaryLength > 280) {
                                                        textA = data.summary.substr(0, 280);
                                                        if ((summaryLength - 280) > 20) {
                                                            textB = data.summary.substr(280, summaryLength);
                                                        } else {
                                                            textA = data.summary;
                                                        }
                                                    }
                                                }

                                                return (
                                                    <div className="result-content mb-30">
                                                        <div className="text1sec">
                                                            <input type="checkbox" name="fields" id={data._id} value={data._id} onChange={this.handleChangeCheckBox.bind(this, data.companyId, data._id)} />
                                                            <label htmlFor={data._id}></label>
                                                            <label className="notcheckkable" onClick={this.viewDetails.bind(this, data)}>{data.title}</label>
                                                            <button className="buttons1 shareJobs" id={"Popover1" + data._id}>Share Job</button>
                                                            <div className="company-desc">{textA}{textB !== "" ? <span><span id={"dots" + i}>...</span><span className="text2sec" id={"text" + i}>{textB}</span>
                                                                <span className="right-caret" onClick={this.readMoreOption.bind(this, i, "right")} id={"right" + i}>Read More</span>
                                                                <span className="down-caret" onClick={this.readMoreOption.bind(this, i, "down")} id={"down" + i}> Read less</span></span> : ''}
                                                                <div className="row">
                                                                    <div className="col-md-3"><span className="style1">Employment Type :</span>&nbsp;{data.employementType}</div>
                                                                    <div className="col-md-3"><span className="style">Experience :</span>&nbsp;{data.experienceRequired}</div>
                                                                    <div className="col-md-3"><span className="style">Opening :</span>&nbsp;{data.opening}</div>
                                                                    <div className="col-md-3"><span className="style">Salary :</span>&nbsp;{data.salary}</div>
                                                                </div>
                                                                <div><span className="style">Company:&nbsp;{data.company[0]}</span></div>
                                                                <div> <a href="#" className="float-right">{this.props.auth.findTimeDiffrence(data.createdAt) + " ago"}</a></div>
                                                            </div>
                                                            <Popover placement="top" isOpen={(this.state.popoverOpen && this.state.popoverOpen[data._id]) ? this.state.popoverOpen[data._id] : false} target={"Popover1" + data._id} toggle={() => this.toggle(data._id)} >
                                                                <PopoverHeader>
                                                                    <button type="button" onClick={() => this.toggle()} className="closeBtn close color-yg" aria-label="Close"><span aria-hidden="true">×</span></button>
                                                                    <span className="shareLink">
                                                                        <input ref={(textarea) => this.textArea1 = textarea} className="singup-control" value={process.env.REACT_APP_HOST + "/" + viewDataDetails.userUrlLink + "/job/" + data.jobId} />
                                                                        <button data-toggle="tooltip" data-placement="bottom" title="Copy Link" className="copybtn buttons1" onClick={() => this.copyCodeToClipboard()}><i className="fa fa-clone" aria-hidden="true"></i></button>
                                                                    </span>
                                                                </PopoverHeader>
                                                            </Popover>
                                                        </div>
                                                    </div>
                                                )

                                            })
                                            }
                                            {/*   {fieldsArr}*/}
                                        </div>
                                        {jobList.length === 0 &&
                                            <span>No data found with these selection</span>
                                        }
                                    </div>
                                    <div className="pagination-block">
                                        <div className="row">
                                            {peginationButton.length > 1 &&
                                                <div className="col-md-12">
                                                    <Pagination aria-label="Page navigation example">
                                                        <PaginationItem onClick={this.pagePrvBack.bind(this, 'prv')} disabled={this.state.activeButton == 1 ? true : false}>
                                                            Prev
                                                        </PaginationItem>
                                                        {peginationButton}
                                                        <PaginationItem onClick={this.pagePrvBack.bind(this, 'next')} disabled={this.state.activeButton * 10 >= this.state.totalCount ? true : false}>
                                                            Next
                                                        </PaginationItem>
                                                    </Pagination>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="button-block">
                                        <div className="row">
                                            <div className="col-md-8">
                                                {jobList.length > 0 &&
                                                    <Button className="btn mrgn resume-btn" onClick={this.sendResume}>Send Resume</Button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <ModalComponent title={(detailsData && detailsData.title) + "    Posted By :  " + (detailsData && detailsData.company && detailsData.company[0])} modalState={this.state.detailsModal} modalBody={viewModelBody} FooterVl={viewModelFooter} action={this.viewDetails} />
                                    <Modal backdrop="static" keyboard={false} isOpen={this.state.resumeSectionModel} toggle={this.resumeUpload} className={this.props.className}>
                                        <ModalHeader toggle={this.resumeUpload}>Send Resume</ModalHeader>
                                        <ModalBody className="spc-radi">
                                            {sendResumeOption &&
                                                <span>
                                                    <div className="modal-wrap">
                                                        <div className="warn-text">{message.sendResumeWithoutSignin}</div>
                                                        <div className="signinPopup">
                                                            <CustomLinkedIN textTtile={"Sign in with LinkedIn"} props={this.props} />
                                                            <button className="btn btn-signIn drop-Signin" title="Sign In" onClick={this.signIn}><i className="fa fa-sign-in"></i> Sign-In</button>&nbsp;
                                                        </div>
                                                    </div>

                                                </span>
                                            }

                                            {!sendResumeOption &&
                                                <div className="row mnge-spce">
                                                    <div className="col-md-12 ">
                                                        <label>Select saved resume</label>
                                                        <input type="radio" name="selectResume" id="profile" className="" value="profile" checked={selectResumeType === "profile"} onChange={this.handleChangeTypeResume} />
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label>Upload new resume</label>
                                                        <input type="radio" name="selectResume" id="upload" className="" value="upload" checked={selectResumeType === "upload"} onChange={this.handleChangeTypeResume} />
                                                    </div>
                                                </div>
                                            }
                                            {!sendResumeOption &&
                                                <div>
                                                    {selectResumeType === "upload" &&
                                                        <form onSubmit={this.sendResumeTo} validate>
                                                            <div className="row">
                                                                {/* <div className="col-md-12">
                                                                    <label>Email<span className="requiredField">*</span></label><br/>
                                                                    <input type="email" className="input-field-control" placeholder="email" name="email" id="userEmail" value={this.state.emailId} onChange={this.emailInput} required/>
                                                                    </div>*/}
                                                                <div className="col-md-12">
                                                                    <div className="box">
                                                                        <h5 className="upload-label">Upload Resume</h5>
                                                                        <div className="upload-icon"><i className="fa fa-upload"></i></div>
                                                                        <input type="file" className="box__file" name="files" id="file" onChange={this.fileSelect.bind(this)} accept=".xlsx,.xls,.doc,.docx,.ppt, .pptx,.txt,.pdf" required />
                                                                        <div className="uploaded-file-name">{fileName}</div>
                                                                        <label htmlFor="file"><strong>Choose a file</strong><span className="box__dragndrop"> or drag it here</span>.</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="modal-btn-block">
                                                                <Button type="submit" className="btn modal-save-btn" disabled={sendResumeOption}>Submit</Button>
                                                                <a type="cancel" className="btn modal-cancel-btn" onClick={this.resumeUpload}>Cancel</a>
                                                            </div>
                                                        </form>
                                                    }

                                                    {/* <input type="radio" className="radio-multiple" name="resumeSendFor" id="key" value="96a2253d-f1ca-499e-8076-54c2859adf92.docx" checked={resumeSendFor === "96a2253d-f1ca-499e-8076-54c2859adf92.docx"}  />*/}
                                                    <div className="remob-p">
                                                        {selectResumeType === "profile" &&
                                                            resumeArr.map((resume, index) => (
                                                                <div className="spc-manage-com">
                                                                    <input type="radio" className="radio-multiple" name="resumeSendFor" id={resume._id} value={resume.resumeImage} checked={resumeSendFor === resume.resumeImage ? true : false} onChange={((e) => this.onChangeForSlctResume(e))} />
                                                                    <span className="pf-label border-sqr spcf-comp">
                                                                        <a href={process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + resume.resumeImage} >{resume.name}</a>
                                                                        {/* <a  onClick={this.fileDownLoads(process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+resume.resumeImage,resume.name)}  >{resume.name}</a> */}
                                                                    </span>
                                                                </div>
                                                            ))

                                                        }

                                                        {resumeNotSelect &&
                                                            <span>Please Select Resume</span>
                                                        }
                                                    </div>

                                                    {selectResumeType === "profile" &&
                                                        <div className="col-md-12 btnfinfcomp">
                                                            <Button type="submit" className="btn modal-save-btn" onClick={this.sendResumeTo} disabled={sendResumeOption}>Submit</Button>
                                                            <a type="cancel" className="btn modal-cancel-btn" onClick={this.resumeUpload}>Cancel</a>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </ModalBody>
                                    </Modal>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        jobType: state.Job.type,
        jobResponse: state.Job.response,
        // responseCityByCountry: state.FindRecCompany && state.FindRecCompany.responseCityByCountry,
        // responseCountry: state.FindRecCompany && state.FindRecCompany.responseCountry,
        fields: state.home.response.data,
        listPost: state.FindRecCompany.response && state.FindRecCompany.response.data ? state.FindRecCompany.response.data : [],
        resume: state.FindRecCompany.resume,
        city: state.FindRecCompany.city,
        resumeSent: state.SendResume.response,
        recruiterView: state.home.responseRecruiter
    };
}

export default withRouter(connect(mapStateToProps, {
    userJobListAction,
    getAllHome,
    getRecruiterView,
    uploadResumeFile,
    sendResumeAction,
    reqUestDeniedByCity,
    listCityCountryStateAction,
    // getAllCountryAction,
    // getAllCityByCountryAction
})(SearchJobCompanyDetails));


// WEBPACK FOOTER //
// ./src/components/Search/SearchJobCompanyDetail.js